const styles = () => ({
    positionRelative: {
        position: 'relative',
    },
    loadingUser: {
        position: 'absolute',
        top: '25px',
        right: '35px',
    },
});

export default styles;
